import { IMAGE_PDF_SUPPORTED_FORMATS, TWO_MB } from '@src/constants';
import * as yup from 'yup';

export interface IBusinessDocumentDocs {
  name: string;
  label: string;
  removeStrict?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const numbersRegex = /^[0-9]+$/;

export const getBusinessDocumentationSchema = (requiredDocs: IBusinessDocumentDocs[]) => {
  // Start with always-present fields
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const baseSchema: Record<string, any> = {
    incorporationCertificate: yup.mixed().required('Certificate of incorporation is required'),
    proofOfBusinessAddress: yup.mixed().required('Proof of Business Address is required')
  };

  // Add dynamic fields from requiredDocs
  requiredDocs.forEach((doc) => {
    baseSchema[doc.name] = yup
      .mixed()
      .nullable()
      .test(
        'FILE_FORMAT',
        'Please check the format of the files selected. The supported formats are jpeg, jpg or png.',
        (value) => {
          if (typeof value === 'string') {
            return true;
          }

          if (value) {
            if (!IMAGE_PDF_SUPPORTED_FORMATS.includes(value?.type)) {
              return false;
            }
          }

          return true;
        }
      )
      .test('FILE_SIZE', 'File too big. Maximum of 2mb', (value) => {
        if (typeof value === 'string') {
          return true;
        }

        if (value) {
          if (value.size > TWO_MB) {
            return false;
          }
        }

        return true;
      })
      .test('IS_REQUIRED', `${doc.label} is required`, (value) => {
        if (doc.removeStrict) {
          return true;
        } else {
          if (!value) {
            return false;
          }
        }

        return true;
      });
    // .required(`${doc.label} is required`);
  });

  return yup.object().shape(baseSchema);
};
